import find from 'lodash/find';
import startCase from 'lodash/startCase';
import get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import RestConfig from '../Common/RestConfig';
import VendorApiConstants from './VendorApiConstants';

/**
 * Function to Vendor related calls.
 */
export const getLatLong = (params) => {
    // use Google library to get lat long based on zipcode
    return new Promise((resolve, reject) => {
        /* istanbul ignore next */
        if (window && window.google) {
            const geocoder = new window.google.maps.Geocoder();
            if (geocoder) {
                const address = `'zipcode ' ${params.zipCode}`;
                /* eslint consistent-return: 0 */
                return geocoder.geocode({ address }, (results, status) => {
                    if (status === 'OK') {
                        const geometry = get(results, '[0].geometry');
                        if (geometry) {
                            const lat = geometry.location.lat();
                            const lng = geometry.location.lng();
                            return resolve({ lat, lng });
                        }
                        return reject(false);
                    }
                    if (status === 'ZERO_RESULTS') {
                        return resolve(null);
                    }
                    return reject(false);
                });
            }
            return reject(false);
        }
        return reject(false);
    });
};

/**
 * Function to get zipcode from a given lat long from Google Geocode API
 */
export const getZipCode = (params) => {
    const config = RestConfig.externalCallConfig();
    config.url = VendorApiConstants.GET_LAT_LONG;
    params.key = VendorApiConstants.GOOGLE_API_KEY;
    config.params = params;

    return RestClient.get(config)
        .then((json) => {
            let result = null;
            if (
                json.data.results &&
                json.data.results[0] &&
                json.data.results[0].address_components
            ) {
                const postalCode = find(json.data.results[0].address_components, {
                    types: ['postal_code'],
                });
                result = postalCode.long_name;
            } else if (json.data.status.indexOf(VendorApiConstants.ZERO_RESULTS) !== -1) {
                result = {};
            }
            return result;
        })
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};

/**
 * Function to get sponsored products from Criteo
 */
export const getCriteoProducts = ({ page, storeContext }) => {
    const url = `?key=804&page-id=${startCase(page)}_Web`;
    const criteoDomain = get(storeContext, 'preferences.criteoHost', {
        testEnvironment: 'd.us.criteo.com/delivery/v2/api/page',
        production: 'd.us.criteo.com/delivery/v2/api/page',
    });
    const context = RestClient.getContext();
    const prodEnv =
        get(storeContext, 'preferences.hostnames.production', []).indexOf(context.hostname) >= 0;
    const host = criteoDomain[prodEnv ? 'production' : 'testEnvironment'];
    const config = {
        host,
        url,
        excludeVersion: true,
        options: {
            jsonpCallback: 'json',
            jsonpCallbackFunction: 'hljson',
        },
    };
    return RestClient.jsonp(config).then((json) => json.data);
};

/**
 * Function to get egain login headers
 */
export const getEgainAuthHeaders = ({ payload, storeContext }) => {
    const egainDomain = get(
        storeContext,
        'preferences.egainDomain',
        VendorApiConstants.egainDomain
    );
    const context = RestClient.getContext();
    const prodEnv =
        get(storeContext, 'preferences.hostnames.production', []).indexOf(context.hostname) >= 0;
    const host = egainDomain[prodEnv ? 'prod' : 'dev'];
    const config = {
        host,
        url: egainDomain.loginAPI,
        excludeVersion: true,
        params: { payload },
        external: true,
    };
    return RestClient.post(config).then((json) => json.data);
};

/**
 * Function to send email to egain
 */
export const sendEmailToEgain = ({ payload, storeContext, customHeaders }) => {
    const egainDomain = get(
        storeContext,
        'preferences.egainDomain',
        VendorApiConstants.egainDomain
    );
    const context = RestClient.getContext();
    const prodEnv =
        get(storeContext, 'preferences.hostnames.production', []).indexOf(context.hostname) >= 0;
    const host = egainDomain[prodEnv ? 'prod' : 'dev'];
    const config = {
        host,
        url: egainDomain.sendEmailAPI,
        excludeVersion: true,
        params: { payload },
        customHeaders,
        external: true,
    };
    return RestClient.post(config).then((json) => json.data);
};

/**
 * Function to trigger beacon for sponsored products from Criteo
 */
export const triggerBeacon = ({ url, customHeaders = {} }) => {
    const config = {
        url,
        host: '',
        external: true,
        customHeaders,
    };
    return RestClient.get(config);
};
